import { Shortcut } from "./shortcut-manager";
import { isAbsent } from "@opendaw/lib-std";
export var ShortcutDefinitions;
(function (ShortcutDefinitions) {
    ShortcutDefinitions.copy = (defs) => {
        const result = {};
        for (const [key, { shortcut, description }] of Object.entries(defs)) {
            result[key] = { shortcut: shortcut.copy(), description };
        }
        return result;
    };
    ShortcutDefinitions.copyInto = (source, target) => {
        for (const [key, { shortcut }] of Object.entries(source)) {
            target[key].shortcut.overrideWith(shortcut.copy());
        }
    };
    ShortcutDefinitions.toJSON = (defs) => {
        const result = {};
        for (const [key, { shortcut }] of Object.entries(defs)) {
            result[key] = shortcut.toJSON();
        }
        return result;
    };
    ShortcutDefinitions.fromJSON = (defs, values) => {
        if (typeof values !== "object" || values === null || Array.isArray(values)) {
            return;
        }
        for (const [key, value] of Object.entries(values)) {
            const def = defs[key];
            if (isAbsent(def)) {
                continue;
            }
            Shortcut.fromJSON(value).ifSome(keys => def.shortcut.overrideWith(keys));
        }
    };
})(ShortcutDefinitions || (ShortcutDefinitions = {}));
export var ShortcutValidator;
(function (ShortcutValidator) {
    ShortcutValidator.validate = (actions) => {
        const entries = Object.entries(actions);
        for (let i = 0; i < entries.length; i++) {
            for (let j = i + 1; j < entries.length; j++) {
                if (entries[i][1].shortcut.equals(entries[j][1].shortcut)) {
                    alert(`Shortcut conflict: '${entries[i][0]}' and '${entries[j][0]}' both use ${entries[i][1].shortcut.format()}`);
                }
            }
        }
        return actions;
    };
})(ShortcutValidator || (ShortcutValidator = {}));
